import { actionTypeCreator, stateChangeOnlyActionTypeCreator } from '../../store/actionCreators';

export const LOGIN_ACTIONTYPE = actionTypeCreator('LOGIN');
export const GET_RECOVERY_LINK_ACTIONTYPE = actionTypeCreator('GET_RECOVERY_LINK')
export const EXECUTE_RESET_PASSWORD_ACTIONTYPE = actionTypeCreator('EXECUTE_RESET_PASSWORD')

export const RESET_RECOVERY_FORM_ACTIONTYPE = stateChangeOnlyActionTypeCreator('RESET_RECOVERY_FORM')
